function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_449",
  "data-name": "Group 449",
  transform: "translate(-811.321 -279.38)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_465",
  "data-name": "Path 465",
  d: "M113.258,87.152c-.087-.22-9.313-13.732-9.313-13.732s6.534-11.25,6.47-11.009C102.8,48.016,80.481,51.634,76.9,65.877c-5.789,23.193,26.849,33.641,33.323,46.437-2.341-8.939-1.861-6.264-7.177-19.092",
  transform: "translate(735.104 226.412)",
  fill: "#f16067"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_466",
  "data-name": "Path 466",
  d: "M84.365,87.868c.087-.22-10.05-14.408-10-14.519s6.385-11.685,6.449-11.443c7.616-14.4,27.813-10.318,31.393,3.925C118,89.024,87.288,98.4,80.814,111.191c-.039-.179-7.281-17.065-7.181-17.069",
  transform: "translate(769.357 226.458)",
  fill: "#f16067"
}));

var SvgHeartRoto = function SvgHeartRoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70.965,
    height: 59.345,
    viewBox: "0 0 70.965 59.345",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartRoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Heart_Roto.fd9b223c.svg";
export { ForwardRef as ReactComponent };